import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { MessageCircle, ChevronRight } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";

export function DashboardOrders({ recentOrders, primaryColor, devise }) {
  if (!recentOrders.length) return null;
  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, delay: 0.28 }}>
      <Card className="border-border/50">
        <CardContent className="p-3 md:p-5">
          <div className="flex items-center justify-between mb-3 md:mb-4">
            <div className="flex items-center gap-2">
              <h2 className="text-base md:text-lg font-semibold">Commandes entrantes</h2>
              {recentOrders.some(o => o.unread_messages > 0 || o.status === 'new') && (
                <span className="inline-flex items-center justify-center w-5 h-5 rounded-full text-white text-xs font-bold animate-pulse"
                  style={{ backgroundColor: '#F97316' }}>
                  {recentOrders.filter(o => o.unread_messages > 0 || o.status === 'new').length}
                </span>
              )}
            </div>
            <Link to="/admin/orders">
              <Button variant="ghost" size="sm" className="text-sm group">
                Voir tout <ChevronRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
          </div>
          <div className="space-y-2">
            {recentOrders.map(order => {
              const hasUnread = order.unread_messages > 0;
              const isNew = order.status === 'new';
              const initials = order.customer_name
                ? order.customer_name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase() : '?';
              return (
                <Link key={order.id} to="/admin/orders" data-testid={`dashboard-order-${order.id}`}>
                  <div className="flex items-center gap-3 p-3 rounded-xl cursor-pointer transition-all hover:bg-secondary/60"
                    style={{
                      background: hasUnread ? `${primaryColor}08` : undefined,
                      border: hasUnread ? `1px solid ${primaryColor}25` : '1px solid transparent',
                    }}>
                    <div className="w-10 h-10 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0"
                      style={{ background: hasUnread ? primaryColor : '#4B5563' }}>
                      {initials}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2">
                        <p className="text-sm font-semibold truncate">{order.customer_name}</p>
                        {isNew && (
                          <span className="text-xs px-1.5 py-0.5 rounded-full bg-blue-500/20 text-blue-400 font-medium">Nouvelle</span>
                        )}
                      </div>
                      <p className="text-xs text-muted-foreground truncate">
                        {order.order_number} · {order.items?.length || 0} article{(order.items?.length || 0) > 1 ? 's' : ''} · {(order.final_price || order.proposed_price || order.subtotal || 0).toLocaleString('fr-FR')} {devise}
                      </p>
                    </div>
                    {hasUnread ? (
                      <span className="w-5 h-5 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0"
                        style={{ backgroundColor: '#EF4444' }}>
                        {order.unread_messages}
                      </span>
                    ) : (
                      <MessageCircle className="w-4 h-4 text-muted-foreground/50 flex-shrink-0" />
                    )}
                  </div>
                </Link>
              );
            })}
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
}
